var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style: _vm.editMode ? "" : "width: 80%; margin: 0 auto",
      attrs: { id: "app-field" },
    },
    [
      _c("h3", [
        _vm._v(_vm._s(_vm.editMode ? "Edit" : "Create New") + " Field"),
      ]),
      _c("div", { attrs: { id: "appField" } }, [
        _c(
          "span",
          [
            _c("small", [_vm._v(" App Field Id ")]),
            _c("el-input", {
              attrs: { disabled: "" },
              model: {
                value: _vm.appField.appFieldId,
                callback: function ($$v) {
                  _vm.$set(_vm.appField, "appFieldId", $$v)
                },
                expression: "appField.appFieldId",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _vm._m(0),
            _c("el-input", {
              attrs: { placeholder: "Enter a unique App Field name" },
              model: {
                value: _vm.appField.appFieldName,
                callback: function ($$v) {
                  _vm.$set(_vm.appField, "appFieldName", $$v)
                },
                expression: "appField.appFieldName",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("small", [_vm._v("Display Name Capture")]),
            _c("el-input", {
              attrs: { placeholder: "Enter a Display Name Capture" },
              model: {
                value: _vm.appField.displayNameCapture,
                callback: function ($$v) {
                  _vm.$set(_vm.appField, "displayNameCapture", $$v)
                },
                expression: "appField.displayNameCapture",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("small", [_vm._v("Display Name PDR")]),
            _c("el-input", {
              attrs: { placeholder: "Enter a Display Name PDR" },
              model: {
                value: _vm.appField.displayNamePDR,
                callback: function ($$v) {
                  _vm.$set(_vm.appField, "displayNamePDR", $$v)
                },
                expression: "appField.displayNamePDR",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("small", [_vm._v("Display Name Fannie Mae")]),
            _c("el-input", {
              attrs: { placeholder: "Enter a Display Name Fannie Mae" },
              model: {
                value: _vm.appField.displayNameFannieMae,
                callback: function ($$v) {
                  _vm.$set(_vm.appField, "displayNameFannieMae", $$v)
                },
                expression: "appField.displayNameFannieMae",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("small", [_vm._v("Assoicated Order Field")]),
            _c("el-input", {
              attrs: { placeholder: "Enter an Assoicated Order Field" },
              model: {
                value: _vm.appField.associatedOrderField,
                callback: function ($$v) {
                  _vm.$set(_vm.appField, "associatedOrderField", $$v)
                },
                expression: "appField.associatedOrderField",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("small", [_vm._v("Description")]),
            _c("el-input", {
              attrs: {
                rows: 3,
                type: "textarea",
                placeholder: "Enter a Description",
              },
              model: {
                value: _vm.appField.description,
                callback: function ($$v) {
                  _vm.$set(_vm.appField, "description", $$v)
                },
                expression: "appField.description",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("small", [_vm._v("Help Description")]),
            _c("el-input", {
              attrs: {
                rows: 3,
                type: "textarea",
                placeholder: "Enter a Help Description",
              },
              model: {
                value: _vm.appField.helpDescription,
                callback: function ($$v) {
                  _vm.$set(_vm.appField, "helpDescription", $$v)
                },
                expression: "appField.helpDescription",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _vm._m(1),
            _c(
              "el-select",
              {
                attrs: { placeholder: "Pick Select-Items List..." },
                on: { change: _vm.handleFieldType },
                model: {
                  value: _vm.appField.fieldTypeName,
                  callback: function ($$v) {
                    _vm.$set(_vm.appField, "fieldTypeName", $$v)
                  },
                  expression: "appField.fieldTypeName",
                },
              },
              _vm._l(
                _vm.$store.state.app.fieldTypeList,
                function (fieldType, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: {
                      label: fieldType.fieldTypeName,
                      value: fieldType.fieldTypeName,
                    },
                  })
                }
              ),
              1
            ),
          ],
          1
        ),
        _c(
          "span",
          [
            _vm._m(2),
            _c(
              "el-select",
              {
                attrs: { placeholder: "Pick Select-Items List..." },
                on: { change: _vm.handleValueType },
                model: {
                  value: _vm.appField.valueTypeName,
                  callback: function ($$v) {
                    _vm.$set(_vm.appField, "valueTypeName", $$v)
                  },
                  expression: "appField.valueTypeName",
                },
              },
              _vm._l(
                _vm.$store.state.app.valueTypeList,
                function (valueType, index) {
                  return _c(
                    "el-option",
                    {
                      key: index,
                      attrs: { value: valueType.type, label: valueType.name },
                    },
                    [_vm._v(" " + _vm._s(valueType.name) + " ")]
                  )
                }
              ),
              1
            ),
          ],
          1
        ),
        _c("span", { staticStyle: { dispay: "flex" } }, [
          _c("small", [_vm._v(" Select Item List ")]),
          _c(
            "span",
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "Pick Select-Items List..." },
                  on: { change: _vm.handleSelectItemList },
                  model: {
                    value: _vm.appField.selectItemListName,
                    callback: function ($$v) {
                      _vm.$set(_vm.appField, "selectItemListName", $$v)
                    },
                    expression: "appField.selectItemListName",
                  },
                },
                _vm._l(
                  _vm.$store.state.app.selectItemList,
                  function (selectItemList, index) {
                    return _c(
                      "el-option",
                      {
                        key: index,
                        attrs: { value: selectItemList.selectItemListName },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(selectItemList.selectItemListName) + " "
                        ),
                      ]
                    )
                  }
                ),
                1
              ),
            ],
            1
          ),
          _vm.appField.selectItemListName
            ? _c(
                "ul",
                _vm._l(
                  _vm.appField.selectItemList.selectItems,
                  function (selectItem) {
                    return _c("li", { key: selectItem.key }, [
                      _vm._v(" " + _vm._s(selectItem.key) + " "),
                    ])
                  }
                ),
                0
              )
            : _vm._e(),
        ]),
        _c(
          "span",
          [
            _c("small", [_vm._v("Truthy value")]),
            _c("el-input", {
              attrs: {
                placeholder:
                  "Enter Truthy Value to be activated by parent field's Related Fields",
              },
              model: {
                value: _vm.appField.truthyValue,
                callback: function ($$v) {
                  _vm.$set(_vm.appField, "truthyValue", $$v)
                },
                expression: "appField.truthyValue",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("small", [_vm._v("Truthy Comparison Operator value")]),
            _c("el-input", {
              attrs: {
                placeholder: "Enter a Truthy Value Comparison operator",
              },
              model: {
                value: _vm.appField.truthyValueComparisonOperator,
                callback: function ($$v) {
                  _vm.$set(_vm.appField, "truthyValueComparisonOperator", $$v)
                },
                expression: "appField.truthyValueComparisonOperator",
              },
            }),
          ],
          1
        ),
        _c("div", { attrs: { id: "jsoneditor" } }),
        _vm.editMode
          ? _c("span", [
              _c("small", [_vm._v("Related fields:")]),
              _c(
                "div",
                { staticClass: "fields-list" },
                [
                  _c(
                    "ul",
                    _vm._l(_vm.appField.relatedFields, function (field) {
                      return _c(
                        "li",
                        {
                          key: field.appFieldId,
                          staticClass: "field-list-item",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                field.appFieldName + " #" + field.appFieldId
                              ) +
                              " "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        placeholder: "Select related",
                      },
                      on: { "remove-tag": _vm.removeRelatedField },
                      model: {
                        value: _vm.appField.relatedFields,
                        callback: function ($$v) {
                          _vm.$set(_vm.appField, "relatedFields", $$v)
                        },
                        expression: "appField.relatedFields",
                      },
                    },
                    _vm._l(_vm.appFields, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.appFieldName, value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm.editMode
          ? _c("span", [
              _c("small", [_vm._v("Children fields:")]),
              _c(
                "div",
                { staticClass: "fields-list" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        placeholder: "Select children",
                      },
                      model: {
                        value: _vm.appField.childrenGroup,
                        callback: function ($$v) {
                          _vm.$set(_vm.appField, "childrenGroup", $$v)
                        },
                        expression: "appField.childrenGroup",
                      },
                    },
                    _vm._l(_vm.appFields, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.appFieldName, value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.handleAdd } },
        [_vm._v(" " + _vm._s(_vm.editMode ? "Save" : "Create") + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _vm._v(" App Field Name "),
      _c("span", [_vm._v("* required")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _vm._v(" Field Type "),
      _c("span", [_vm._v("* required")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _vm._v(" Value Type "),
      _c("span", [_vm._v("* required")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }